export const steps = [
  {
    target: "body",
    content: "Welcome to Kalyanawaran! Let's take a quick tour.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tour="nav-Login"]',
    content: "Click here to Login to your account.",
  },
  {
    target: '[data-tour="nav-My Profile"]',
    content: "Here you can update your profile details.",
  },
  {
    target: '[data-tour="nav-Search Profile"]',
    content: "Use this to search for other profiles.",
  },
];
